import extractRawElm from './extract-raw-elm'

export default function getElmsRange($first, $second) {
  const first = extractRawElm($first)
  const second = extractRawElm($second)

  return first.contains(second)
    ? getElmsRangeInternal($first, $second, true)
    : getElmsRangeInternal($second, $first, false)
}

function getElmsRangeInternal($fromElm, $toElm, shouldReverse) {
  const fromElm = extractRawElm($fromElm)
  const toElm = extractRawElm($toElm)

  if (!fromElm.contains(toElm)) {
    return []
  }

  let currElm = toElm
  const range = [toElm]
  while (!!currElm.parentNode && currElm.parentNode !== fromElm.parentNode && currElm.parentNode !== document) {
    range.push(currElm.parentNode)
    currElm = currElm.parentNode
  }

  return shouldReverse
    ? range.reverse()
    : range
}
